import { createCn } from 'shared-utils'

export const circleLinkCn = createCn('circle-link')
